import React, {useEffect} from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {removeFromCart} from "../../../actions/actionFunctions";
import {cartItemInterface} from "../cartItemInterface";
import {checkForDeletePopup, removeCartItemsWithQuoteIndex} from "./advancedQuotingFunctions";
import {usePrevious} from "../../../misc/helperHooks";
import {deleteCartItemsFromSQFTCalcData, updateCurrentQuote} from "../../../misc/quotesFunctions";

const AdvancedQuotingListItemRemoveButton = (props) => {

  let {cartItem, removeFromCart, deleteEmptyCartItem, quoteIndex, confirmPopupTag, fabricatorSettings, isDisabled} = props;

  const prevConfirmPopupTag = usePrevious(confirmPopupTag);

  useEffect(() => {
    if (confirmPopupTag && confirmPopupTag.allowDelete && prevConfirmPopupTag && prevConfirmPopupTag.fromDelete
      && prevConfirmPopupTag.cartItem && (prevConfirmPopupTag.cartItem.id === cartItem.id)) { // update on close and apply
      removeCartItemsWithQuoteIndex(quoteIndex, removeFromCart);
      deleteCartItem();
    }
  }, [confirmPopupTag]); // eslint-disable-line react-hooks/exhaustive-deps

  const deleteCartItem = async () => {
    cartItem.isEmpty ? deleteEmptyCartItem(cartItem) : removeFromCart(cartItem);
    if (fabricatorSettings.useCategorySwitching) {
      await updateCurrentQuote(cartItem.currentQuote)
    }
    deleteCartItemsFromSQFTCalcData([cartItem]).then(r => void r);
  }

  const handleDeleteClick = () => {
    if (isDisabled) {
      return false
    }
    if (checkForDeletePopup(cartItem, null, quoteIndex, true)) {
      return false
    }
    deleteCartItem();
  };

  return (
    <div className="aq-cell aq-cell--remove">
      {cartItem.isMinimumCharge ? null : <button className="ui-close ui-close--gray" onClick={handleDeleteClick}/>}
    </div>
  )
};

AdvancedQuotingListItemRemoveButton.propTypes = {
  cartItem: PropTypes.shape(cartItemInterface),
  deleteEmptyCartItem: PropTypes.func.isRequired,
  quoteIndex: PropTypes.number.isRequired,
  isDisabled: PropTypes.bool,
};

const mapStateToProps = (store) => {
  const {confirmPopupTag} = store.userState;
  const fabricatorSettings = store.fabricatorState.settings;
  return {
    confirmPopupTag,
    fabricatorSettings,
  };
};

const mapDispatchToProps = {
  removeFromCart,
};

export default connect(mapStateToProps, mapDispatchToProps)(AdvancedQuotingListItemRemoveButton)

